import React from 'react';
import Navbar from './components/Navbar';
import Rail from './components/Rail';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Skills from './components/Skills';
import CV from './components/CV';
import Contact from './components/Contact';
import Footer from './components/Footer';
import useReveal from './hooks/useReveal';

function App() {
  useReveal();
  return (
    <>
      <Navbar />
      <Rail />
      <Hero />
      <About />
      <Projects />
      <Skills />
      <CV />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
